import './visual-category-navigation.scss';

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Carousel } from '@thd-olt-component-react/carousel';
import { Image } from '@thd-olt-component-react/image';
// import { useSearch } from '@thd-nucleus/data-sources';
import { useSearchDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { track } from './analytics';
import Helpers from './helper';
import { dataModel } from './dataModel';

const PRODUCT_CATALOG_IMAGE_PATH = 'https://images.homedepot-static.com/catalog/productImages';

const VisualCategoryNavigation = (props) => {
  const { channel } = useContext(ExperienceContext);

  const {
    slider,
    showArrows,
    keyword,
    navParam
  } = props;

  let disableSwipeNavigation;
  if (channel === 'mobile') {
    disableSwipeNavigation = props.disableSwipeNavigation;
  }

  // eslint-disable-next-line
  const isControlledData = typeof props.data !== 'undefined' || typeof props.loading !== 'undefined';

  // eslint-disable-next-line
  const searchResponse = useSearchDeprecated({ keyword, navParam, domains: ['relatedResults', 'dimensions'], skip: isControlledData });

  let data;
  // eslint-disable-next-line
  if (typeof props.data !== 'undefined') {
    ({ data } = props);
  } else {
    ({ data } = searchResponse);
  }

  if (!data) return null;

  const { visualNavs, visualNavContainsEvents } = data?.searchModel?.relatedResults || [];
  const { dimensions } = data?.searchModel || [];

  if (!visualNavs?.length) {
    return null;
  }

  const getSpecialValuesRefinement = () => {
    const priceDimension = dimensions?.filter((dimension) => dimension?.label === 'Price')[0];
    return priceDimension?.refinements.find((refinement) => refinement?.refinementKey === '7');
  };

  const buildClasses = (opts) => {
    const {
      title,
      wrapper,
      link,
      img,
      span,
      isMobileSlider
    } = opts;
    return classNames({
      'vis-nav__link': link,
      'vis-nav__link--mobile': link && disableSwipeNavigation,
      'vis-nav__link--default': link && !isMobileSlider,
      'vis-nav__wrapper': wrapper,
      'vis-nav__mobile--wrapper': wrapper && isMobileSlider,
      'vis-nav__wrapper--slide': wrapper && isMobileSlider && !disableSwipeNavigation,
      'vis-nav__wrapper--default': wrapper && !isMobileSlider,
      'vis-nav__title': title,
      'vis-nav__title--slide': title && isMobileSlider,
      'vis-nav__title--default': title && !isMobileSlider,
      'vis-nav-imgSlide': img && isMobileSlider,
      stretchy: img && !isMobileSlider,
      'vis-nav__image': span && isMobileSlider,
      'vis-nav__image--mobile': span && isMobileSlider && disableSwipeNavigation
    });
  };

  const renderVisNav = ({
    // eslint-disable-next-line react/prop-types
    key = 'visualNavs', classes, isMobileSlider, url, label, analytics, src
  }) => {
    return (
      <div key={key} className={classes}>
        <a
          className={buildClasses({ link: true, isMobileSlider })}
          href={url}
          title={label}
          onClick={() => track(analytics)}
        >
          <div className={buildClasses({ wrapper: true, isMobileSlider })}>
            <span className={buildClasses({ span: true, isMobileSlider })}>
              <Image
                src={src}
                alt={label}
                title={label}
                className={buildClasses({ img: true, isMobileSlider })}
              />
            </span>
          </div>
          <div className={buildClasses({ title: true, isMobileSlider })}>
            <div className="vis-nav__text">{label}</div>
          </div>
        </a>
      </div>
    );
  };

  const addSpecialSavingsToVisNav = (normalizedVisNavs) => {
    const specialValues = getSpecialValuesRefinement();
    if (!specialValues) {
      return normalizedVisNavs;
    }
    const analytics = {
      categoryId: 'savings',
    };
    const specialbuyVisualNav = {
      key: 'specialbuy',
      url: specialValues.url,
      label: 'Shop Savings',
      analytics,
      src: 'https://assets.homedepot-static.com/images/special-buy--pod.jpg'
    };
    normalizedVisNavs.push(specialbuyVisualNav);
    return normalizedVisNavs;
  };

  const getVisNav = (isMobileSlider) => {
    const {
      hasLeftNav
    } = props;
    const size = 300;
    const classes = classNames('vis-nav', {
      'vis-nav-description': isMobileSlider,
      'vis-nav--6': !isMobileSlider && hasLeftNav,
      'vis-nav--8': !isMobileSlider && !hasLeftNav
    });

    let normalizedVisNavs = [];

    visualNavs.forEach((visualNav) => {
      const {
        label, imageId, webUrl, categoryId, imageURL = ''
      } = visualNav;
      const imgUrl = imageId
        ? `${PRODUCT_CATALOG_IMAGE_PATH}/${size}/${imageId.substring(0, 2)}/${imageId}_${size}.jpg`
        : imageURL;
      const productUrl = `${webUrl}`;
      const analytics = {
        categoryId,
      };
      normalizedVisNavs.push({
        key: imageId,
        url: productUrl,
        label,
        analytics,
        src: imgUrl
      });
    });
    if (!visualNavContainsEvents) {
      normalizedVisNavs = addSpecialSavingsToVisNav(normalizedVisNavs);
    }
    return normalizedVisNavs.map((visNav, index) => {
      const {
        key,
        url,
        label,
        analytics,
        src
      } = visNav;
      return renderVisNav({
        key,
        classes,
        isMobileSlider,
        url,
        label,
        analytics: { ...analytics, position: index + 1 },
        src
      });
    });
  };

  const isMobileSlider = (channel === 'mobile' && slider);
  const getVisNavFunc = getVisNav(isMobileSlider);
  return (
    <div className="visual-category-navigation">
      {isMobileSlider ? (
        <Carousel
          itemWidthMobile="35%"
          disableSwipeNavigation={disableSwipeNavigation}
          showArrows={showArrows}
          channel="mobile"
        >
          {getVisNavFunc}
        </Carousel>
      ) : (
        <div className="visual-category-content">
          <>
            {getVisNavFunc}
          </>
        </div>
      ) }
    </div>
  );

};

VisualCategoryNavigation.Helpers = Helpers;

VisualCategoryNavigation.dataModel = dataModel;

VisualCategoryNavigation.propTypes = {
  disableSwipeNavigation: PropTypes.bool,
  hasLeftNav: PropTypes.bool,
  showArrows: PropTypes.bool,
  slider: PropTypes.bool,
  keyword: PropTypes.string,
  navParam: PropTypes.string,
  data: PropTypes.shape({}),
  loading: PropTypes.bool
};

VisualCategoryNavigation.defaultProps = {
  hasLeftNav: false,
  disableSwipeNavigation: false,
  showArrows: true,
  slider: false,
  keyword: '',
  navParam: '',
  data: undefined,
  loading: undefined
};

export { VisualCategoryNavigation };
